import { GMOUDto } from './../../../../../data/src/lib/dto/gmou.dto';
import { DocumentSubCategoryFacade } from './../../../../../epims-references/src/lib/states/+document-sub-category/document-sub-category.facade';
import { CurrencyFacade } from './../../../../../epims-references/src/lib/states/+currency/currency.facade';
import { DocumentCategoryFacade } from './../../../../../epims-references/src/lib/states/+document-category/document-category.facade';
import { OilFieldFacade } from './../../../../../epims-references/src/lib/states/+oil-field/oil-field.facade';
import { OilBlockFacade } from './../../../../../epims-references/src/lib/states/+oil-block/oil-block.facade';
import { CommunityFacade } from './../../../../../epims-references/src/lib/states/+community/community.facade';
import { ClusterCommunityFacade } from './../../../../../epims-references/src/lib/states/+cluster-community/cluster-community.facade';
import { ClusterFacade } from './../../../../../epims-references/src/lib/states/+cluster/cluster.facade';
import { ProjectCategoryFacade } from './../../../../../epims-references/src/lib/states/+project-category/project-category.facade';
import { ProjectTypeFacade } from './../../../../../epims-references/src/lib/states/+project-type/project-type.facade';
import { LgaFacade } from './../../../../../epims-references/src/lib/states/+lga/lga.facade';
import { StateFacade } from './../../../../../epims-references/src/lib/states/+state/state.facade';
import { CountryFacade } from './../../../../../epims-references/src/lib/states/+country/country.facade';
import { Component, OnInit } from '@angular/core';
import {
  ProjectDto,
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  CommunityDto,
  OilBlockDto,
  OilFieldDto,
  CurrencyDto,
  DocumentSubCategoryDto,
  DocumentCategoryDto,
} from '@cradua/data';
import { Observable } from 'rxjs';
import { GmouFacade } from '../../states/+gmou/gmou.facade';

@Component({
  selector: 'mrsoftapps-gmou-container',
  templateUrl: './gmou-container.component.html',
  styleUrls: ['./gmou-container.component.scss'],
})
export class GmouContainerComponent implements OnInit {
  isLoadingGmou$: Observable<any>;
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingProjectType$: Observable<any>;
  isLoadingProjectCategory$: Observable<any>;
  isLoadingCluster$: Observable<any>;
  isLoadingClusterCommunity$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingOilBlock$: Observable<any>;
  isLoadingOilField$: Observable<any>;
  isLoadingDocumentCategory$: Observable<any>;
  isLoadingDocumentSubCategory$: Observable<any>;
  isLoadingCurrency$: Observable<any>;

  gmou$: Observable<GMOUDto[]>;
  searchGmou$: Observable<ProjectDto[]>;
  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  projectType$: Observable<ProjectTypeDto[]>;
  projectCategory$: Observable<ProjectCategoryDto[]>;
  cluster$: Observable<ClusterDto[]>;
  clusterCommunity$: Observable<ClusterCommunityDto[]>;
  community$: Observable<CommunityDto[]>;
  oilBlock$: Observable<OilBlockDto[]>;
  oilField$: Observable<OilFieldDto[]>;
  documentCategory$: Observable<DocumentCategoryDto[]>;
  documentSubCategory$: Observable<DocumentSubCategoryDto[]>;
  currency$: Observable<CurrencyDto[]>;
  projectData: ProjectDto;

  task = 'list';
  constructor(
    private gmouFacade: GmouFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private projectTypeFacade: ProjectTypeFacade,
    private projectCategoryFacade: ProjectCategoryFacade,
    private communityFacade: CommunityFacade,
    private oilBlockFacade: OilBlockFacade,
    private oilFieldFacade: OilFieldFacade
  ) {}

  ngOnInit() {
    this.isLoadingGmou$ = this.gmouFacade.isLoadingGmou;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingOilBlock$ = this.oilBlockFacade.isLoadingOilBlock;
    this.isLoadingProjectType$ = this.projectTypeFacade.isLoadingProjectType;
    this.isLoadingProjectCategory$ = this.projectCategoryFacade.isLoadingProjectCategory;
    this.isLoadingOilField$ = this.oilFieldFacade.isLoadingOilField;

    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.oilBlock$ = this.oilBlockFacade.loadOilBlock;
    this.projectType$ = this.projectTypeFacade.loadProjectType;
    this.projectCategory$ = this.projectCategoryFacade.loadProjectCategory;
    this.oilField$ = this.oilFieldFacade.loadOilField;
    this.gmou$ = this.gmouFacade.loadGmou;
  }

  onTriggerEmit(value) {
    this.gmouFacade.addGmou(value);
  }

  taskEvent(value) {}
}
